import React from "react";
import type { SiteEvent } from "../content/events";
import Gallery from "./Gallery";

function EventCard({ event }: { event: SiteEvent }) {
  return (
    <article className="event-card" id={event.slug}>
      <div className="event-card-head">
        <span className={`status-pill status-${event.status}`}>
          {event.status === "upcoming" ? "Upcoming" : "Past event"}
        </span>
        <span className="event-date">{event.dateLabel}</span>
      </div>

      <h2 className="event-title">{event.title}</h2>

      <dl className="event-meta">
        {event.timeLabel ? (
          <div>
            <dt>Time</dt>
            <dd>{event.timeLabel}</dd>
          </div>
        ) : null}
        <div>
          <dt>Location</dt>
          <dd>{event.location}</dd>
        </div>
      </dl>

      <p className="event-description">{event.description}</p>

      {event.highlights ? (
        <ul className="event-highlights">
          {event.highlights.map((h) => (
            <li key={h.title}>
              <h3>{h.title}</h3>
              <p>{h.text}</p>
            </li>
          ))}
        </ul>
      ) : null}

      {event.gallery ? (
        <div className="event-gallery">
          <Gallery photos={event.gallery} altPrefix={`${event.title} photo`} />
        </div>
      ) : null}
    </article>
  );
}

export default EventCard;
